import React from "react";
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { gengetURLTEST, genpostURL, genURL } from './../_getjson.js';
import Backdrop from './../Components/CustomBackdrop/Barckdrop'
import axios from 'axios'
import MaterialUIPickers from "./../Components/CustomDatepicker/MaterialUIPickers"
import Grid from '@mui/material/Grid';
require('./../_css/PopUpOther.css');

export const ReDate = (TimeStamp) => {
    var myDate = new Date(TimeStamp);
    var date = (myDate.getDate() < 10 ? '0' : '') + (myDate.getDate());
    var month = (myDate.getMonth() + 1 < 10 ? '0' : '') + (myDate.getMonth() + 1);
    var year = myDate.getFullYear() + 543;
    return date + "/" + month + "/" + year;
}
export const ReDate2 = (date) => {
    var dateSp = date.split("/");
    var dataRe = dateSp[2] - 543 + "-" + dateSp[1] + "-" + dateSp[0];
    return dataRe
}
export const startdate = () => {
    var myDate = new Date();
    var date = "01"
    var month = (myDate.getMonth() + 1 < 10 ? '0' : '') + (myDate.getMonth() + 1);
    var year = myDate.getFullYear() + 543;
    return date + "/" + month + "/" + year;
}
const mystyle = {
    paddingTop: '0px',
    // paddingLeft:'0px'
};
export default class SearchDoc extends React.Component {
    constructor(props) {
        super(props);
        this.DOCNO1 = React.createRef();
        this.DOCNO2 = React.createRef();
        this.SALECODE = React.createRef();
        this.DEPARTMENT = React.createRef();
        this.SITECODE = React.createRef();
        this.ARCODE = React.createRef();
        this.OWNERCODE = React.createRef();
        this.CURRENCYCODE = React.createRef();
        this.ITEMLIST = React.createRef();
        this.state = {
            rows: [],
            Htext: '',
            _from: '',
            openBackdrop: false,
            DATE1: startdate(),
            DATE2: '',
        }
    }
    componentDidMount() {
        this.setState({ _from: this.props.from });
        setTimeout(() => {
            this.onSearch();
        }, 200);

    }

    onClose = (e) => {
        this.props.closePopup();
    }
    /* หมวด: ขาย */
    ViewCSTV = (DATA) => {
        console.log("popup", DATA);
        switch (DATA) {
            case "CSCUSTORDER": this.setState({ Htext: "บันทึกใบสั่งจองสินค้า", test: "CSCUSTORDER" }); return "CSCUSTORDER/Search?";
            case "CSSALEORDER": this.setState({ Htext: "บันทึกใบสั่งขาย/สั่งจัดสินค้า", test: "CSSALEORDER" }); return "CSSALEORDER/Search?";
            case "CSSALE": this.setState({ Htext: "บันทึกขายสินค้า/บริการ", test: "CSSALE" }); return "CSSALE/Search?";
            case "CSQUOT": this.setState({ Htext: "บันทึกใบเสนอราคาขาย", test: "CSQUOT" }); return "CSQUOT/Search?";
            case "CSSALERETREQ": this.setState({ Htext: "บันทึกใบเสนอราคาขาย", test: "CSSALERETREQ" }); return "CSSALERETREQ/Search?";
            case "CSSALERET": this.setState({ Htext: "บันทึกใบเสนอราคาขาย", test: "CSSALERET" }); return "CSSALERET/Search?";
            default: break;
        }
    }
    onSearch = async () => {
        this.setState({ openBackdrop: true })
        var url = this.ViewCSTV(this.props.from);
        url += "SITECODE=" + this.SITECODE.current.value;
        url += "&DATE1=" + ReDate2(this.state.DATE1) + " 00:00:00";
        url += "&DATE2=" + ReDate2(this.state.DATE2) + " 00:00:00";
        url += "&DOCNO1=" + this.DOCNO1.current.value;
        url += "&DOCNO2=" + this.DOCNO2.current.value;
        url += "&SALECODE=" + this.SALECODE.current.value;
        url += "&DEPARTMENT=" + this.DEPARTMENT.current.value;
        url += "&ARCODE=" + this.ARCODE.current.value;
        /* เอกสารอ้างอิง */
        url += "&OWNERCODE=" + this.OWNERCODE.current.value;
        url += "&CURRENCYCODE=" + this.CURRENCYCODE.current.value;
        url += "&provenance="
        /* กลุ่มเอกสาร */
        url += "&top=" + this.ITEMLIST.current.value;
        var data = [];
        console.log("popup", genURL(url));
        await axios.get(genURL(url), { timeout: 60000 }).then(res => {
            console.log("popup", res.data);
            if (res.data.length > 0) {
                for (var i = 0; i < res.data.length; i++) {
                    console.log(res.data.length);
                    data[i] = {
                        C0: i + 1,
                        DOCDATE: ReDate(res.data[i].DOCDATE),
                        DOCNO: res.data[i].DOCNO,
                        C2: res.data[i].TAXNO,
                        C3: "",
                        ARCODE: res.data[i].ARCODE,
                        arname: res.data[i].ARNAME,
                        remark: res.data[i].REMARK,
                        amount: parseFloat(res.data[i].DEBTAMOUNT).toFixed(2),
                        C8: res.data[i].EXSYMBOL,
                        C9: res.data[i].DOCNO,
                        username: res.data[i].SALENAME,
                        department: res.data[i].DEPNAME,
                        project: "",
                        CREATEUSER: res.data[i].CREATEUSER,
                        CREATE: ReDate(res.data[i].DOCDATE),
                        UPDATEUSER: res.data[i].UPDATEUSER,
                        UPDATE: ReDate(res.data[i].DOCDATE),
                    }
                    if (i === res.data.length - 1) {
                        this.setState({ rows: data });
                        this.setState({ openBackdrop: false })
                    }
                }
            } else {
                this.setState({ rows: data });
                this.setState({ openBackdrop: false })
            }
        }).catch(error => {
            this.setState({ openBackdrop: false })
            console.log(error);
        });
    }
    SelectSetData = (data1, data2) => {
        switch (data1) {
            case "Calendar1": this.setState({ DATE1: data2 }); break;
            case "Calendar2": this.setState({ DATE2: data2 }); break;
            default: break;
        }
    }
    onSelectRow = (data) => {
        console.log(data, "test");
        this.props.Get_Popup(data);
        this.props.closePopup();
    }
    KeyUp = (e) => {
        switch (e.target.id) {
            case "DOCNO1":
                this.DOCNO2.current.value = e.target.value;
                break;
            default: break;
        }
        if (e.key === "Enter") {
            this.onSearch();
        }
    }




    render() {
        const price = this.state.test; let comp; let comp1;
        if (price === "CSSALE") {
            comp = <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="left" width="140" dataField='C2'> ใบกำกับภาษี </TableHeaderColumn>
            comp1 = "ใบวางบิล"
        }
        else if (price === "CSSALE1") {
            comp = <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="left" width="140" dataField='C2'> ใบกำกับภาษี </TableHeaderColumn>
        }
        else { comp1 = "บิลขาย" }
        return (
            <div className='popup' >
                <Backdrop open={this.state.openBackdrop} />
                <div className='popup_inner'>
                    <div className="PopUpOtherDivH" align="left">
                        <div className="PopUpOtherDivH1"><i className="fas fa-search" > {this.state.Htext}  </i></div>
                        <div className="PopUpOtherDivH2"><i className="fas fa-times" onClick={this.props.closePopup}></i></div>
                    </div>
                    <div className="panel-body divTable" align="right">

                        <Grid container spacing={2}>
                            <Grid item xs={6} >
                                <MaterialUIPickers title="วันที่"
                                    DateValue={e => this.SelectSetData("Calendar1", e)}
                                    defaultdate={this.state.DATE1}
                                    Popup={true} />
                            </Grid>
                            <Grid item xs={6}>

                                <MaterialUIPickers title="ถึง"
                                    DateValue={e => this.SelectSetData("Calendar2", e)}
                                    defaultdate={this.state.DATE2}
                                    Popup={true} />

                            </Grid>
                            <Grid item xs={6} style={mystyle}>
                                <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12 FromGroupPOPUP">
                                    <div className="float-left input-group col-xs-12 col-sm-12 col-lg-12 col-md-12 form-inline1">
                                        <span className="input-group-addon"> เลขที่เอกสาร: </span>
                                        <input type="text" className="form-control" id="DOCNO1" ref={this.DOCNO1} onKeyUp={this.KeyUp} />
                                        <span className="input-group-addon icon"><i className="fab fa-expeditedssl"></i></span>
                                    </div>
                                </div>
                            </Grid>
                            <Grid item xs={6} style={mystyle}>
                                <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12 FromGroupPOPUP">
                                    <div className="float-left input-group col-xs-12 col-sm-12 col-lg-12 col-md-12 form-inline1">
                                        <span id="iconCreditCode" className="input-group-addon ">ถึง: </span>
                                        <input type="text" className="form-control" id="DOCNO2" ref={this.DOCNO2} onKeyUp={this.KeyUp} />
                                        <span className="input-group-addon icon"><i className="fab fa-expeditedssl"></i></span>
                                    </div>
                                </div>
                            </Grid>
                            <Grid item xs={6} style={mystyle}>
                                <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12 FromGroupPOPUP">
                                    <div className="float-left input-group col-xs-12 col-sm-12 col-lg-12 col-md-12 form-inline1">
                                        <span className="input-group-addon"> พนักงานขาย: </span>
                                        <input type="text" className="form-control" id="SALECODE" ref={this.SALECODE} onKeyUp={this.KeyUp} />
                                        <span className="input-group-addon icon"><i className="fab fa-expeditedssl"></i></span>
                                    </div>
                                </div>
                            </Grid>
                            <Grid item xs={6} style={mystyle}>
                                <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12 FromGroupPOPUP">
                                    <div className="float-left input-group col-xs-12 col-sm-12 col-lg-12 col-md-12 form-inline1">
                                        <span id="iconCreditCode" className="input-group-addon ">แผนก: </span>
                                        <input type="text" className="form-control" id="DEPARTMENT" ref={this.DEPARTMENT} onKeyUp={this.KeyUp} />
                                        <span className="input-group-addon icon"><i className="fab fa-expeditedssl"></i></span>
                                    </div>
                                </div>
                            </Grid>
                            <Grid item xs={6} style={mystyle}>
                                <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12 FromGroupPOPUP">
                                    <div className="float-left input-group col-xs-12 col-sm-12 col-lg-12 col-md-12 form-inline1">
                                        <span className="input-group-addon"> สาขา: </span>
                                        <input type="text" className="form-control" id="SITECODE" ref={this.SITECODE} onKeyUp={this.KeyUp} />
                                        <span className="input-group-addon icon"><i className="fab fa-expeditedssl"></i></span>
                                    </div>
                                </div>
                            </Grid>
                            <Grid item xs={6} style={mystyle}>
                                <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12 FromGroupPOPUP">
                                    <div className="float-left input-group col-xs-12 col-sm-12 col-lg-12 col-md-12 form-inline1">
                                        <span id="iconCreditCode" className="input-group-addon ">ลูกค้า: </span>
                                        <input type="text" className="form-control" id="ARCODE" ref={this.ARCODE} onKeyUp={this.KeyUp} />
                                        <span className="input-group-addon icon"><i className="fab fa-expeditedssl"></i></span>
                                    </div>
                                </div>
                            </Grid>
                            <Grid item xs={6} style={mystyle}>
                                <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12 FromGroupPOPUP">
                                    <div className="float-left input-group col-xs-12 col-sm-12 col-lg-12 col-md-12 form-inline1">
                                        <span className="input-group-addon"> เอกสารอ้างอิง: </span>
                                        <input type="text" className="form-control" /* id="OWNERCODE" ref={this.OWNERCODE}  */ onKeyUp={this.KeyUp} />
                                        <span className="input-group-addon icon"><i className="fab fa-expeditedssl"></i></span>
                                    </div>
                                </div>
                            </Grid>
                            <Grid item xs={6} style={mystyle}>
                                <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12 FromGroupPOPUP">
                                    <div className="float-left input-group col-xs-12 col-sm-12 col-lg-12 col-md-12 form-inline1">
                                        <span id="iconCreditCode" className="input-group-addon ">ผู้บันทึก: </span>
                                        <input type="text" className="form-control" id="OWNERCODE" ref={this.OWNERCODE} onKeyUp={this.KeyUp} />
                                        <span className="input-group-addon icon"><i className="fab fa-expeditedssl"></i></span>
                                    </div>
                                </div>
                            </Grid>
                            <Grid item xs={6} style={mystyle}>
                                <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12 FromGroupPOPUP">
                                    <div className="float-left input-group col-xs-12 col-sm-12 col-lg-12 col-md-12 form-inline1">
                                        <span className="input-group-addon"> สกุลเงิน: </span>
                                        <input type="text" className="form-control" id="CURRENCYCODE" ref={this.CURRENCYCODE} onKeyUp={this.KeyUp} />
                                        <span className="input-group-addon icon"><i className="fab fa-expeditedssl"></i></span>
                                    </div>
                                </div>
                            </Grid>
                            <Grid item xs={6} style={mystyle}>
                                <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12 FromGroupPOPUP">
                                    <div className="float-left input-group col-xs-12 col-sm-12 col-lg-12 col-md-12 form-inline1">
                                        <span id="iconCreditCode" className="input-group-addon "/* subinput */>กลุ่มเอกสาร: </span>
                                        <input type="text" className="form-control" /* id="DOCNO2" ref={this.DOCNO2} onKeyUp={this.KeyUp} */ />
                                        <span className="input-group-addon icon"><i className="fab fa-expeditedssl"></i></span>
                                    </div>
                                </div>
                            </Grid>
                            <Grid item xs={6} style={mystyle}>
                                <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12 FromGroupPOPUP">
                                    <div className="float-left input-group col-xs-12 col-sm-12 col-lg-12 col-md-12 form-inline1">
                                        <span className="input-group-addon"> จำนวนรายการ: </span>
                                        <input type="text" className="form-control" id="ITEMLIST" ref={this.ITEMLIST} onKeyUp={this.KeyUp} />
                                        <span className="input-group-addon icon"><i className="fab fa-expeditedssl"></i></span>
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                        <button className="PUSDbtn" onClick={this.onSearch.bind(null)}><i className="fas fa-search" > ค้นหา </i></button>
                        <div className="DivTable">
                            <BootstrapTable
                                data={this.state.rows}
                                options={{
                                    onRowClick: this.onSelectRow,
                                    noDataText: "ไม่พบข้อมูล"

                                }}
                                height='500'
                                hover condensed>
                                <TableHeaderColumn columnClassName="columnAll columnID" className="columnNumber" dataAlign="center" width="40" dataField='C0' isKey> </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="center" width="20%" dataField='DOCDATE' > วันที่เอกสาร </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="center" width="30%" dataField='DOCNO'> เลขที่เอกสาร </TableHeaderColumn>
                                {comp}
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="left" width="10%" dataField='ARCODE'> รหัสลูกค้า</TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="left" width="30%" dataField='arname'> ชื่อลูกค้า </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="left" width="10%" dataField='remark'> หมายเหตุ </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="right" width="30%" dataField='amount'> รวมเงินทั้งสิ้น </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="center" width="25" dataField='C8'> C </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="left" width="120" dataField='C9'> {comp1} </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="left" width="10%" dataField='username'> พนักงานขาย </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="left" width="10%" dataField='department' hidden> แผนก </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="left" width="10%" dataField='project' hidden> โครงการ </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="left" width="10%" dataField='CREATEUSER' hidden> CREATEUSER </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="left" width="10%" dataField='CREATE' hidden> CREATE </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="left" width="10%" dataField='UPDATEUSER' hidden> UPDATEUSER </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="left" width="10%" dataField='UPDATE' hidden> UPDATE </TableHeaderColumn>
                            </BootstrapTable>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
